import { render, staticRenderFns } from "./StartTab.vue?vue&type=template&id=1c1e496c&scoped=true&"
import script from "./StartTab.vue?vue&type=script&lang=js&"
export * from "./StartTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e496c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1e496c')) {
      api.createRecord('1c1e496c', component.options)
    } else {
      api.reload('1c1e496c', component.options)
    }
    module.hot.accept("./StartTab.vue?vue&type=template&id=1c1e496c&scoped=true&", function () {
      api.rerender('1c1e496c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box-configuration/components/StartTab.vue"
export default component.exports